import ClientManagementDashboard from './client_management';
import { RootState } from '../../redux/store';
import SalesDashboard from './sales';
import { useSelector } from 'react-redux';

const DashboardPage = () => {
    const { isSales } = useSelector((state: RootState) => state.app);

    if (isSales) {
        return <ClientManagementDashboard />;
    }
    return <SalesDashboard />;
};
export default DashboardPage;